// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"StatusIcons-module__statusIcon___1zYj7"};